var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose"},_vm._l((_vm.colors),function(item,index){return _c('span',{staticClass:"c",style:({background:item}),on:{"click":function($event){_vm.selectOne(index)}}},[_c('i',{staticClass:"iconfont",style:({color: index === 0 ? '#000' : '#FFF'}),domProps:{"innerHTML":_vm._s( index === _vm.selected ? _vm.html : '')}})])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23f09916","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chooseColor.vue
// module id = null
// module chunks = 